import { ReactNode } from "react";
import { Text } from "@merge-api/merge-javascript-shared";

// Small presentational atoms shared across the conductor detail views.

// A label/value pair for a definition-list (`<dl>`) layout.
export const KV = ({ label, children }: { label: string; children: ReactNode }) => (
  <>
    <dt className="text-gray-60">
      <Text variant="sm">{label}</Text>
    </dt>
    <dd className="m-0 flex flex-wrap items-center gap-2">{children}</dd>
  </>
);

// Monospaced value (ids, cadences, counts).
export const Mono = ({ children }: { children: ReactNode }) => (
  <Text variant="md" className="font-mono">
    {children}
  </Text>
);

// Muted value (null/placeholder text).
export const Muted = ({ children }: { children: ReactNode }) => (
  <Text variant="md" className="text-gray-60">
    {children}
  </Text>
);
